import '../assets/beautrium-css/event-popup.scss'
import logo from '../assets/img/beautrium/campaign/cny/logo.png'
import BG from '../assets/img/beautrium/campaign/cny/cny-popup-bg-tr.png'
import mouseCry from '../assets/img/beautrium/campaign/cny/mouse-cry.png'
import mouseCoupon from '../assets/img/beautrium/campaign/cny/mouse-coupon.png'
import flowerPast from '../assets/img/beautrium/campaign/cny/flower-past.png'
import flowerToday from '../assets/img/beautrium/campaign/cny/flower-today.png'
import flowerFuture from '../assets/img/beautrium/campaign/cny/flower-future.png'
import flowerLoading from '../assets/img/beautrium/campaign/cny/flower-loading.png'
import _ from 'lodash'
import moment from 'moment';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-duotone-svg-icons'
import {withRouter} from 'react-router-dom'
import {showEventPopup} from '../actions/common/index'
import {getCoupons} from '../actions/coupon/index'

// import CouponCard from './coupon/CouponCard';
import { getRoute } from '../assets/util';
import LoadingInsideDiv from './LoadingInsideDiv';
import CouponCard from './coupon/CouponCard';
class EventPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            eventObj: null,
            eventStep: 1,
            coupon: null,
            reward: null,
        }
        this.onFailedColected = this.onFailedColected.bind(this)
        this.onSuccessCollected = this.onSuccessCollected.bind(this)

    }

    componentDidMount() {
        fetch(getRoute(`/event`), {
            method: 'post',
            body: JSON.stringify({event_code: 'CNY2020'}),
            accept: 'application/json',
            credentials: 'include'
        })
        .then(response => response.json())
        .then(response => {
            this.setState({eventObj: response, eventStep: 1})
        })
        .catch(err => {
            this.setState({eventObj: {}, eventStep: 1})
        })
        // this.props.getCoupons({coupon_id: [8]});
    }

    componentDidUpdate(prevProps) {
        if (this.props.eventPopup !== prevProps.eventPopup) {
            this.setState({eventStep: 1})
        }
    }

    onSuccessCollected() {
        // this.props.getCoupons({coupon_id: [8]});
    }

    onFailedColected() {
        // this.props.showEventPopup(false)
        // this.props.history.push('/login')
    }

    getCouponByCode(coupons, code) {
        return _.find(coupons, (c) => c.promo_code === code)
    }

    onStep1Handle() {
        this.setState({eventStep: 2})
        fetch(getRoute(`/event/ticket`), {
            method: 'post',
            body: JSON.stringify({event_code: 'CNY2020'}),
            accept: 'application/json',
            credentials: 'include'
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.type === "success") {
                fetch(getRoute(`/event/reward`), {
                    method: 'post',
                    body: JSON.stringify({event_code: 'CNY2020'}),
                    accept: 'application/json',
                    credentials: 'include'
                })
                .then((response) => response.json())
                .then((data) => {
                    this.setState({eventStep: 3, reward: data.reward, coupon: data.coupon})
                })
            } else {
                this.setState({eventStep: 3, message: response.message, coupon: null, reward: null})
                // fetch(getRoute(`/event/reward/get`), {
                //     method: 'post',
                //     body: JSON.stringify({event_code: 'CNY2020'}),
                //     accept: 'application/json',
                //     credentials: 'include'
                // })
                // .then((response) => response.json())
                // .then((data) => {
                //     console.log (data[0])
                //     const coupon = _.pick(data[0], ['promo_id', 'start_date', 'end_date', 'desc', 'promo_code', 'quantity', 'remain', 'discount_amt', 'discount_percent', 'max_cap', 'group_id', 'status', 'type', 'user_limit', 'new_user', 'public'])
                //     coupon.id = +coupon.promo_id
                //     console.log (coupon)
                //     this.setState({eventStep: 3, reward: data[0], coupon: coupon})
                // })
            }
        })
    }

    renderEventSteps() {
        const {eventStep} = this.state
        const {authenticated} = this.props
        const startDate = "2020-01-24"
        // let eventStep = 3
        if (eventStep === 1) {
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-5 col-md-4 mx-auto">
                            <img src={logo} alt="BEAUTRIUM" className="w-100" />
                        </div>
                        <div className="col-12">
                            <h1>แจกอั่งเปาฟรี !</h1>
                        </div>
                        <div className="col-12">
                            <p>ตรุษจีนนี้แจกอั่งเปาเป็นคูปองลดราคา<br />สำหรับสินค้าออนไลน์ เพียงแค่เข้าสู่ระบบ<br/><span className="color-white bold">แจกเลยตลอด 14 วัน ! (24 ม.ค. - 6 ก.พ.)</span></p>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between cny-command">
                        <div className="col-8">
                            {
                                authenticated
                                ?   <div className="position-relative" style={{paddingTop: "100%"}}>
                                        <img src={mouseCoupon} alt="BEAUTRIUM Chinese New Year 2020" style={{width: "100%", height: "auto", position: "absolute", top: 0, left: 0}} />
                                        <button type="button" className="btn btn-white btn-cny" style={{position: "absolute", bottom: "-20px", left: "50%", transform: "translateX(-50%)"}} onClick={() => {
                                            this.onStep1Handle()
                                        }}>รับอั่งเปา</button>
                                    </div>
                                :   <div className="position-relative d-flex align-items-center h-100">
                                        <button type="button" className="btn btn-white btn-cny btn-longtext" onClick={() => {
                                            this.props.showEventPopup(false)
                                            this.props.history.push({pathname: '/login', state: {ref: '/deals', message: 'โปรดเข้าสู่ระบบหรือสมัครสมาชิกก่อนลุ้นรับอั่งเปาค่ะ'}})
                                        }}>โปรดเข้าสู่ระบบก่อนค่ะ</button>
                                    </div>
                            }
                        </div>
                        <div className="col-4 text-center calendar">
                            <div className="text-center">
                                <ul>
                                    {_.times(14, (t) => {
                                        const listDay = moment(startDate).add(t, 'd')
                                        const before = listDay.isBefore(moment(), 'd')
                                        const today = listDay.isSame(moment(), 'd')
                                        return <li key={"day_"+ t}><img src={before? flowerPast: (today? flowerToday: flowerFuture)} alt="today" /></li>
                                    })}
                                </ul>
                            </div>
                            <div className="text-1">แจกอั่งเปาแล้ว</div>
                            <div className="text-day">{moment().diff(startDate, 'd')} <span style={{color: "#ffdea4"}}>วัน</span></div>
                        </div>
                    </div>
                </div>
            )
        } else if (eventStep === 2) {
            return (
                <div className="d-flex justify-content-center align-items-center step-2">
                    <div style={{width: "50%", margin: "auto"}}>
                        <img src={flowerLoading} alt="BEAUTRIUM Chinese New Year 2020" className="w-100 flower-loading" />
                    </div>
                </div>
            )
        } else if (eventStep === 3) {
            const {coupon, reward, message} = this.state
            if (!coupon && !reward) {
                return (
                    <div className="d-flex justify-content-center align-items-center step-3-error">
                        <div style={{width: "80%", margin: "auto", fontSize: "20px", color: "#fff"}}>
                            <div className="text-center">{message}</div>
                            <div className="text-center text-bottom">{moment().isBefore("2020-02-06 00:00:00", 's')? "มาลองสุ่มใหม่ได้ในวันพรุ่งนี้นะคะ": "ไว้พบกันใหม่กิจกรรมหน้านะคะ (พรุ่งนี้มีกิจกรรมวาเลนไทน์ค่ะ)"}</div>
                        </div>
                    </div>
                )
            } else if (!coupon && reward) {
                return (
                    <div className="container step-3-cry">
                        <div className="row">
                            <div className="col-8 col-md-6 mx-auto">
                                <img src={mouseCry} alt="BEAUTRIUM อั่งเปา" className="w-100" />
                            </div>
                            <div className="col-12 text-center color-white mt-2 text-cry">
                                <div>เสียใจด้วย</div>
                                <div>วันนี้อดได้อั่งเปา</div>
                            </div>
                            <div className="text-bottom">{moment().isBefore("2020-02-06 00:00:00", 's')? "มาลองสุ่มใหม่ในวันพรุ่งนี้นะคะ": "ไว้พบกันใหม่กิจกรรมหน้านะคะ (พรุ่งนี้มีกิจกรรมวาเลนไทน์ค่ะ)"}</div>
                        </div>
                    </div>
                )
            }
            return (
                <div className="container step-3-success">
                    <div className="row">
                        <div className="col-12">
                            <h1>ยินดีด้วย !</h1>
                            <h2 style={{color: "#fcd27e"}}>ได้อั่งเปาแล้ว</h2>
                        </div>
                        <div className="col-12 my-3">
                            <CouponCard attraction={true} simpleDesign={true} coupon={coupon} onSuccessCollected={() => {this.props.getCoupons({coupon_id: [coupon.id]})}} />
                        </div>
                        <div className="col-12 mx-auto mt-2">
                            <div className="d-flex flex-column justify-content-between">
                                <div className="col-12 reward text-center">
                                    <div style={{color: "#fff", lineHeight: 1.3, fontWeight: "500"}}>คุณได้รับคูปองมูลค่า <span style={{color: "#dbb666"}}>{coupon.discount_amt}</span> บาท</div>
                                </div>
                            </div>
                        </div>
                        <div style={{position: "absolute", width: "100%", bottom: "15px", left: "50%", transform: "translateX(-50%)"}}>
                            <div className="col-12 text-center text-1">{moment().isBefore("2020-02-06 00:00:00", 's')? "มาลองสุ่มใหม่ในวันพรุ่งนี้นะคะ": "ไว้พบกันใหม่กิจกรรมหน้านะคะ (พรุ่งนี้มีกิจกรรมวาเลนไทน์ค่ะ)"}</div>
                            <div className="col-12 text-center text-remark">หมายเหตุ คูปองนี้จะมีอายุเพียง 24 ชั่วโมงเท่านั้นนะคะ</div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return null
        }
    }

    render() {
        const {eventPopup} = this.props //showEventPopup
        const {eventObj} = this.state
        if (!eventPopup) {
            return null
        }
        return (
            <div className="bt-popup-backdrop bt-popup-backdrop-white">
                <div className="bt-popup bt-popup-event" style={{backgroundImage: `url(${BG})`, backgroundPosition: "top center", backgroundRepeat: 'no-repeat'}}>
                    <label className="btn-close close-btn" style={{zIndex: 1}} onClick={() => {this.props.showEventPopup(false); localStorage.setItem('EventPopupForceCloseDate', moment().format("YYYY-MM-DD"))}}>
                        <FontAwesomeIcon icon={faTimesCircle} style={{height: "16px", width: "16px"}} />
                    </label>
                    {eventObj
                    ? this.renderEventSteps()
                    : <LoadingInsideDiv />}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        eventPopup: state.common.event_popup,
        couponUrl: state.coupon.couponUrl,
        coupons: state.coupon.coupons? state.coupon.coupons.data: []
    }
}
export default withRouter(connect(mapStateToProps, {showEventPopup, getCoupons})(EventPopup))